import React from "react";
import { Box, Typography, Container, Avatar } from "@mui/material";
import Grid from "@mui/material/Grid";
import "./WhereEveryFundraiserSection.css";
import FundraiserCard from "../FundraiserCard/FundraiserCard";
import Tag from "../Tag/Tag";
import PrimaryButton from "../Buttons/PrimaryButton";

const WhereEveryFundraiserSection: React.FC = (): JSX.Element => {
  return (
    <Box className="fundraiser-section">
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} sx={{ position: "relative" }}>
            <Typography variant="h3" fontWeight={700} gutterBottom>
              Where every fundraiser <br />
              <Box component="span" sx={{ color: "#d6ff65" }}>
                becomes a memory
              </Box>{" "}
              worth keeping
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Custom online stores for your team, with no order forms, no
              hassle, and real results
            </Typography>
            <Box className="button-container">
              <PrimaryButton href="/new-fundraiser-request">
                Start Your Fundraiser
              </PrimaryButton>
              <PrimaryButton href="/faq">Get More Information</PrimaryButton>
            </Box>
            <Box sx={{ mt: 4, display: "flex", alignItems: "center", gap: 2 }}>
              <Avatar src="/usasf.png" alt="USASF" />
              <Typography variant="body2">
                Trusted by over 1,000 organizations nationwide
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: "relative",
              width: "100%",
              padding: 0,
              margin: 0,
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                "& img": {
                  width: "100%",
                  height: "auto",
                  maxHeight: "500px",
                  objectFit: "contain",
                  "@media (max-width: 900px)": {
                    width: "100vw",
                    maxWidth: "100vw",
                    marginLeft: "calc(-1 * ((100vw - 100%) / 2))",
                    padding: 0,
                  },
                },
                "@media (min-width: 900px)": {
                  maxWidth: "800px",
                  margin: "0 auto",
                },
              }}
            >
              <img
                src="/images/fundraiser-showcase.png"
                alt="Fundraiser showcase"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "500px",
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WhereEveryFundraiserSection;
